import { render, staticRenderFns } from "./WorkerHeader.vue?vue&type=template&id=67b1451a"
import script from "./WorkerHeader.vue?vue&type=script&lang=ts"
export * from "./WorkerHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports